import React, { useState } from 'react';
import './Orders.css';
import SideBar from '../SideBar/SideBar';

interface OrderItem {
  id: number;
  productName: string;
  quantity: number;
  price: number;
}

interface Order {
  id: number;
  customerName: string;
  date: string;
  total: number;
  status: 'Pending' | 'Completed' | 'Shipped' | 'Cancelled';
  items: OrderItem[];
}

const Orders: React.FC = () => {
  const [orders, setOrders] = useState<Order[]>([
    { 
      id: 1001, 
      customerName: 'Άννα Παπαδοπούλου', 
      date: '2023-10-25', 
      total: 45.50, 
      status: 'Completed',
      items: [{ id: 1, productName: 'Matte Pomade', quantity: 2, price: 18.00 }, { id: 2, productName: 'Comb', quantity: 1, price: 9.50 }]
    },
    { 
      id: 1002, 
      customerName: 'Γιώργος Γεωργίου', 
      date: '2023-10-26', 
      total: 22.00, 
      status: 'Pending',
      items: [{ id: 3, productName: 'Shaping Clay', quantity: 1, price: 22.00 }]
    },
    { 
      id: 1003, 
      customerName: 'Μαρία Οικονόμου', 
      date: '2023-10-26', 
      total: 60.00, 
      status: 'Shipped',
      items: [{ id: 4, productName: 'Argan Oil Shampoo', quantity: 2, price: 24.00 }, { id: 5, productName: 'Conditioner', quantity: 1, price: 12.00 }]
    },
    { 
      id: 1004, 
      customerName: 'Κώστας Δημητρίου', 
      date: '2023-10-27', 
      total: 18.00, 
      status: 'Cancelled',
      items: [{ id: 1, productName: 'Matte Pomade', quantity: 1, price: 18.00 }]
    },
     { 
      id: 1005, 
      customerName: 'Ελένη Νικολάου', 
      date: '2023-10-28', 
      total: 35.00, 
      status: 'Pending',
      items: [{ id: 6, productName: 'Beard Oil', quantity: 2, price: 15.00 }, { id: 7, productName: 'Brush', quantity: 1, price: 5.00 }]
    },
  ]);

  const [searchTerm, setSearchTerm] = useState('');
  const [statusFilter, setStatusFilter] = useState<string>('All');
  const [selectedOrder, setSelectedOrder] = useState<Order | null>(null);

  const handleStatusChange = (id: number, newStatus: Order['status']) => {
      setOrders(orders.map(o => o.id === id ? { ...o, status: newStatus } : o));
  };

  const filteredOrders = orders.filter(order => {
      const matchesSearch = order.customerName.toLowerCase().includes(searchTerm.toLowerCase()) || 
                            order.id.toString().includes(searchTerm);
      const matchesStatus = statusFilter === 'All' || order.status === statusFilter;
      return matchesSearch && matchesStatus;
  });

  const getStatusText = (status: string) => {
       switch(status) {
          case 'Completed': return 'Ολοκληρώθηκε';
          case 'Pending': return 'Σε Εκκρεμότητα';
          case 'Shipped': return 'Απεστάλη';
          case 'Cancelled': return 'Ακυρώθηκε';
          default: return status;
      }
  };

  return (
    <div className="admin-container">
      <SideBar />
      <div className="admin-content">
        
        <div className="page-header">
            <h2>Διαχείριση Παραγγελιών</h2>
            
             <div className="search-wrapper">
                <input 
                    type="text" 
                    placeholder="Αναζήτηση (Όνομα ή ID)..." 
                    className="order-search-input"
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                />
                <span className="search-icon">🔍</span>
            </div>
        </div>

        {/* Status Filters */}
        <div className="status-tabs">
            {['All', 'Pending', 'Shipped', 'Completed', 'Cancelled'].map(status => (
                <button 
                    key={status} 
                    className={`status-tab ${statusFilter === status ? 'active' : ''}`}
                    onClick={() => setStatusFilter(status)}
                >
                    {status === 'All' ? 'Όλες' : getStatusText(status)}
                </button>
            ))}
        </div>
        
        <div className="orders-list">
             <div className="orders-header-row">
                <div className="col-id">ID</div>
                <div className="col-user">Πελάτης</div>
                <div className="col-date">Ημερομηνία</div>
                <div className="col-total">Σύνολο</div>
                <div className="col-status">Κατάσταση</div>
                <div className="col-actions">Ενέργειες</div>
             </div>

            {filteredOrders.length > 0 ? filteredOrders.map((order) => (
              <div className="order-row" key={order.id}>
                <div className="col-id"><strong>#{order.id}</strong></div>
                <div className="col-user">{order.customerName}</div>
                <div className="col-date">{order.date}</div>
                <div className="col-total">{order.total.toFixed(2)}€</div>
                <div className="col-status">
                    <span className={`status-badge ${order.status.toLowerCase()}`}>
                        {getStatusText(order.status)}
                    </span>
                </div>
                <div className="col-actions">
                  <button className="view-btn" onClick={() => setSelectedOrder(order)}>
                      👁️ Λεπτομέρειες
                  </button>
                  <select 
                    value={order.status} 
                    onChange={(e) => handleStatusChange(order.id, e.target.value as Order['status'])}
                    className="status-select-mini"
                    onClick={(e) => e.stopPropagation()}
                  >
                      <option value="Pending">Εκκρεμεί</option>
                      <option value="Shipped">Απεστάλη</option>
                      <option value="Completed">Ολοκληρώθηκε</option>
                      <option value="Cancelled">Ακυρώθηκε</option>
                  </select>
                </div>
              </div>
            )) : (
                <div className="no-orders">Δεν βρέθηκαν παραγγελίες.</div>
            )}
        </div>

        {/* Order Details Modal */}
        {selectedOrder && (
            <div className="modal-overlay">
                <div className="modal-content">
                    <div className="modal-header">
                         <h3>Παραγγελία #{selectedOrder.id}</h3>
                         <button className="close-btn" onClick={() => setSelectedOrder(null)}>×</button>
                    </div>
                    
                    <div className="modal-body">
                        <div className="order-info-grid">
                            <div className="info-item">
                                <label>Πελάτης</label>
                                <span>{selectedOrder.customerName}</span>
                            </div>
                             <div className="info-item">
                                <label>Ημερομηνία</label>
                                <span>{selectedOrder.date}</span>
                            </div>
                             <div className="info-item">
                                <label>Κατάσταση</label>
                                <span className={`status-badge ${selectedOrder.status.toLowerCase()}`}>
                                    {getStatusText(selectedOrder.status)}
                                </span>
                            </div>
                        </div>

                        <h4>Προϊόντα</h4>
                        <table className="order-items-table">
                            <thead>
                                <tr>
                                    <th>Προϊόν</th>
                                    <th>Ποσότητα</th>
                                    <th>Τιμή</th>
                                    <th>Σύνολο</th>
                                </tr>
                            </thead>
                            <tbody>
                                {selectedOrder.items.map((item, idx) => (
                                    <tr key={idx}>
                                        <td>{item.productName}</td>
                                        <td>x{item.quantity}</td>
                                        <td>{item.price.toFixed(2)}€</td>
                                        <td>{(item.price * item.quantity).toFixed(2)}€</td>
                                    </tr>
                                ))}
                            </tbody>
                            <tfoot>
                                <tr>
                                    <td colSpan={3}><strong>Συνολικό Ποσό:</strong></td>
                                    <td><strong>{selectedOrder.total.toFixed(2)}€</strong></td>
                                </tr>
                            </tfoot>
                        </table>

                         <div className="modal-actions">
                            <button className="cancel-btn" onClick={() => setSelectedOrder(null)}>Κλείσιμο</button>
                        </div>
                    </div>
                </div>
            </div>
        )}

      </div>
    </div>
  );
};

export default Orders;
